import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M21 11.25V20.25C21 20.449 20.921 20.6397 20.7803 20.7804C20.6397 20.921 20.4489 21 20.25 21H15C14.8011 21 14.6103 20.921 14.4697 20.7804C14.329 20.6397 14.25 20.449 14.25 20.25V15.375C14.25 15.2756 14.2105 15.1802 14.1402 15.1099C14.0698 15.0395 13.9745 15 13.875 15H10.125C10.0255 15 9.93016 15.0395 9.85983 15.1099C9.78951 15.1802 9.75 15.2756 9.75 15.375V20.25C9.75 20.449 9.67098 20.6397 9.53033 20.7804C9.38968 20.921 9.19891 21 9 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7804C3.07902 20.6397 3 20.449 3 20.25V11.25C3.00018 10.8523 3.15834 10.4709 3.43969 10.1897L10.9397 2.68972C11.221 2.40863 11.6023 2.25073 12 2.25073C12.3977 2.25073 12.779 2.40863 13.0603 2.68972L20.5603 10.1897C20.8417 10.4709 20.9998 10.8523 21 11.25Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconHome'

export const IconHome = memo(themed(Icon))
